var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilLine = function SvgPencilLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.884 5.834 6.593 18.125H2.375v-4.218l12.291-12.29 4.218 4.217Zm-15.259 8.59v2.451h2.45l11.04-11.041-2.449-2.45-11.041 11.04Z"
  })));
};
export { SvgPencilLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTguODgzOCA1LjgzMzk4TDYuNTkyNzcgMTguMTI1SDIuMzc1VjEzLjkwNzJMMTQuNjY2IDEuNjE2MjFMMTguODgzOCA1LjgzMzk4Wk0zLjYyNSAxNC40MjQ4VjE2Ljg3NUg2LjA3NDIyTDE3LjExNTIgNS44MzM5OEwxNC42NjYgMy4zODM3OUwzLjYyNSAxNC40MjQ4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";